import { faTrashCan } from '@fortawesome/free-solid-svg-icons';
import { Router } from '@angular/router';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Registry } from '@/registry.service';
import { DialogPopUpComponent } from '@components/dialog-pop-up/dialog-pop-up.component';
import { LoggerService } from '@services/logger.service';
import { Component, OnInit } from '@angular/core';
import { ButtonComponent } from '@components/button/button.component';
import { ToastrService } from 'ngx-toastr';
import { MenuBiConfigModel } from '@/models/tables/menu-bi-config.model';
import { MenuBiConfigService } from '@services/data-source-tables/menu-bi-config.service';

@Component({
  selector: 'app-button-menu-bi-delete',
  templateUrl: '../../button.component.html',
  styleUrls: ['../../button.component.scss'],
})
export class ButtonDeleteMenuBIComponent extends ButtonComponent implements OnInit {
  faIcon = faTrashCan;
  private menuBIModel: MenuBiConfigModel;
  private rowData: any;

  constructor(
    protected router: Router,
    public dialog: MatDialog,
    protected menuBiService: MenuBiConfigService,
    protected toastr: ToastrService,
  ) {
    super(router, toastr);

    this.color = 'danger';
    this.additionalClass = 'py-0.5 px-2.5';
    this.showIcon = true;
    this.smallBtn = true;
  }

  ngOnInit() {
    this.menuBIModel = <MenuBiConfigModel>this.rowData;
  }

  /**
   * Delete user
   */
  public actionClick(): void {
    let dialogRef = this.dialog.open(DialogPopUpComponent, {
      width: 'auto',
      panelClass: 'custom-modalbox',
    });

    this.setupPopup(dialogRef);

    dialogRef.afterClosed().subscribe((deleteMenuBI) => {
      if (deleteMenuBI) {
        this.menuBiService.deleteMenuBI(this.menuBIModel.id).subscribe({
          next: () => {
            this.toastr.success('Menu BI cancellato correttamente!');

            Registry.getInstance().get('MenuBiConfigComponent').loadMenuBiConfig();
          },
          error: (error) => {
            LoggerService.error('deleteMenuBI failed!');
            LoggerService.error(error);

            this.toastr.error(`Errore durante la cancellazione del Menu BI.`);
          },
          complete: () => {
            LoggerService.log('Request done');
          },
        });
      }
    });
  }

  private setupPopup(dialogRef: MatDialogRef<DialogPopUpComponent>) {
    dialogRef.componentInstance.title = 'Confermi di voler cancellare questo Menu BI?';
    dialogRef.componentInstance.content =
      'Attenzione una volta cancellato questo Menu BI non sarà più possibile recuperarlo.';
    dialogRef.componentInstance.firstCTA = 'Si cancella';
    dialogRef.componentInstance.secondCTA = 'Annulla operazione';
    dialogRef.componentInstance.closeResultFirst = true;
    dialogRef.componentInstance.closeResultSecond = false;
  }
}
